import { render, staticRenderFns } from "./DriverNextOrders.vue?vue&type=template&id=4fc5761a&scoped=true&"
import script from "./DriverNextOrders.vue?vue&type=script&lang=ts&"
export * from "./DriverNextOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc5761a",
  null
  
)

export default component.exports